import {
	createAchBankLinkingSession,
	type CreateAchBankLinkingSessionParams,
	type CreateAchBankLinkingSessionResult,
} from "@/api/processor-ach-bank-linking";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

export const createAchBankLinkingSessionMutationKey = [
	"processor-ach-bank-linking-session",
] as const;

export type UseCreateAchBankLinkingSessionOptions = Omit<
	UseMutationOptions<
		CreateAchBankLinkingSessionResult,
		Error,
		CreateAchBankLinkingSessionParams
	>,
	"mutationFn"
>;

export default function useCreateAchBankLinkingSession(
	options?: UseCreateAchBankLinkingSessionOptions,
) {
	return useMutation({
		mutationKey: createAchBankLinkingSessionMutationKey,
		mutationFn: createAchBankLinkingSession,
		...options,
	});
}
